import React from 'react';
import './PDFStyleStep.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const PDFStyleStep = ({ selectedLayout, selectedColor, onColorSelect, selectedFont, onFontSelect }) => {
    
    // Paletas de colores predefinidas
    const colorPalettes = [
        { id: 'orange', name: 'Naranja Vibrante', primary: '#fa7e17', secondary: '#ff9a3c', accent: '#e06d0f' },
        { id: 'blue', name: 'Azul Profesional', primary: '#2563eb', secondary: '#3b82f6', accent: '#1d4ed8' },
        { id: 'green', name: 'Verde Natural', primary: '#10b981', secondary: '#34d399', accent: '#059669' },
        { id: 'purple', name: 'Púrpura Elegante', primary: '#8b5cf6', secondary: '#a78bfa', accent: '#7c3aed' },
        { id: 'red', name: 'Rojo Intenso', primary: '#ef4444', secondary: '#f87171', accent: '#dc2626' },
        { id: 'teal', name: 'Turquesa Moderno', primary: '#14b8a6', secondary: '#2dd4bf', accent: '#0d9488' },
        { id: 'pink', name: 'Rosa Creativo', primary: '#ec4899', secondary: '#f472b6', accent: '#db2777' },
        { id: 'gray', name: 'Gris Minimalista', primary: '#6b7280', secondary: '#9ca3af', accent: '#4b5563' }
    ];

    // Opciones de fuentes
    const fontOptions = [
        { id: 'modern', name: 'Moderna', family: 'Inter, system-ui, sans-serif', preview: 'Catálogo 2026' },
        { id: 'classic', name: 'Clásica', family: 'Georgia, serif', preview: 'Catálogo 2026' },
        { id: 'elegant', name: 'Elegante', family: 'Playfair Display, serif', preview: 'Catálogo 2026' },
        { id: 'bold', name: 'Bold', family: 'Montserrat, sans-serif', preview: 'Catálogo 2026' }
    ];

    // Obtener nombre del layout
    const getLayoutName = () => {
        const names = {
            'alternado': 'Alternado',
            'doble-columna': 'Doble Columna',
            'grid-3x3': 'Grid 3x3'
        };
        return names[selectedLayout] || selectedLayout;
    };

    return (
        <div className="pdf-style-step-container">
            
            {/* Mini Preview del Layout Seleccionado */}
            <div className="pdf-style-layout-preview">
                <div className="pdf-style-layout-badge">
                    <FontAwesomeIcon icon={faCheck} />
                    <span>Layout: {getLayoutName()}</span>
                </div>
            </div>

            {/* Selector de Paleta de Colores */}
            <div className="pdf-style-section">
                <h4 className="pdf-style-section-title">Paleta de Colores</h4>
                <p className="pdf-style-section-description">
                    Selecciona la paleta de colores para tu catálogo
                </p>
                
                <div className="pdf-style-color-grid">
                    {colorPalettes.map((palette) => (
                        <div
                            key={palette.id}
                            className={`pdf-style-color-card ${selectedColor === palette.id ? 'selected' : ''}`}
                            onClick={() => onColorSelect(palette.id)}
                        >
                            <div className="pdf-style-color-circles">
                                <div 
                                    className="pdf-style-color-circle primary"
                                    style={{ background: palette.primary }}
                                ></div>
                                <div 
                                    className="pdf-style-color-circle secondary"
                                    style={{ background: palette.secondary }}
                                ></div>
                                <div 
                                    className="pdf-style-color-circle accent"
                                    style={{ background: palette.accent }}
                                ></div>
                            </div>
                            <span className="pdf-style-color-name">{palette.name}</span>
                            {selectedColor === palette.id && (
                                <div className="pdf-style-color-selected-badge">
                                    <FontAwesomeIcon icon={faCheck} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {/* Selector de Fuente */}
            <div className="pdf-style-section">
                <h4 className="pdf-style-section-title">Tipografía</h4>
                <p className="pdf-style-section-description">
                    Elige el estilo de fuente para tu catálogo
                </p>
                
                <div className="pdf-style-font-grid">
                    {fontOptions.map((font) => (
                        <div
                            key={font.id}
                            className={`pdf-style-font-card ${selectedFont === font.id ? 'selected' : ''}`}
                            onClick={() => onFontSelect(font.id)}
                        >
                            <div 
                                className="pdf-style-font-preview"
                                style={{ fontFamily: font.family }}
                            >
                                {font.preview}
                            </div>
                            <span className="pdf-style-font-name">{font.name}</span>
                            {selectedFont === font.id && (
                                <div className="pdf-style-font-selected-badge">
                                    <FontAwesomeIcon icon={faCheck} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
};

export default PDFStyleStep;
